// eslint-disable-next-line import/no-cycle
import feathersClient from '../../feathers-client';

const defaultMappingPagination = {
	total: 100,
	$skip: 0,
	$limit: 7,
};

const defaultMappingFilter = {
	$skip: defaultMappingPagination.$skip,
	$limit: defaultMappingPagination.$limit,
};

export default {
	namespaced: true,
	state: {
		staffPersonaMappings: [],
		mappingFilter: defaultMappingFilter,
		mappingPagination: defaultMappingPagination,
	},
	getters: {
		mappingPage: (state) => {
			const { $limit, $skip } = state.mappingPagination;
			return $skip / $limit + 1;
		},
		staffPersonaMappings: (state) => state.staffPersonaMappings,
	},
	mutations: {
		SET_STAFF_PERSONA_MAPPINGS: (state, staffPersonaMappings) => { state.staffPersonaMappings = staffPersonaMappings; },
		SET_MAPPING_FILTER: (state, filter) => { state.mappingFilter = { ...state.mappingFilter, ...filter }; },
		SET_DEFAULT_MAPPING_FILTER: (state, filter) => { state.mappingFilter = { ...filter, ...defaultMappingFilter }; },
		SET_MAPPING_PAGINATION: (state, data) => { state.mappingPagination = { ...state.mappingPagination, ...data }; },
	},
	actions: {
		loadStaffPersonaMappings: async ({ rootGetters, commit }, filter) => {
			const url = '/api/v3/staffpersonamappings';
			const results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole, fields: ['jobTitle', 'owner', 'careSpecialities', 'staffPersonas'], ...filter } });
			commit('SET_STAFF_PERSONA_MAPPINGS', results.data);
			commit('SET_MAPPING_PAGINATION', { total: results.total });
			return results;
		},
		setMappingFilter: ({ commit }, filter) => {
			commit('SET_MAPPING_FILTER', filter);
		},
		setDefaultMappingFilter: ({ commit }, filter) => {
			commit('SET_DEFAULT_MAPPING_FILTER', filter);
		},
		setMappingPage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.mappingPagination.$limit;
			commit('SET_MAPPING_PAGINATION', { $skip });
			commit('SET_MAPPING_FILTER', { $skip });
		},
		searchPersonas: async ({ rootGetters }, filter) => {
			const url = '/api/v3/staffpersonas';
			const results = await feathersClient.service(url).find({ $paginate: false, query: { $role: rootGetters.currentUserRole, $paginate: false, ...filter } });
			return results;
		},
		addStaffPersonaMapping: async ({ rootGetters }, data) => {
			const url = '/api/v3/staffpersonamappings';
			const results = await feathersClient.service(url).create(data, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		addStaffPersonaStaffPersonaMappings: async ({ rootGetters }, data) => {
			const url = '/api/v3/staffpersonamappingstaffpersonas';
			const results = await feathersClient.service(url).create(data, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		deleteStaffPersonaStaffPersonaMapping: async ({ rootGetters }, filter) => {
			const url = '/api/v3/staffpersonamappingstaffpersonas';
			const results = await feathersClient.service(url).remove(null, { query: { $role: rootGetters.currentUserRole, ...filter } });
			return results;
		},
		deleteStaffPersonaStaffPersonaMappingForMain: async ({ rootGetters }, filter) => {
			const url = '/api/v3/staffpersonamappingstaffpersonas';
			const results = await feathersClient.service(url).remove(null, { query: { $role: rootGetters.currentUserRole, ...filter } });
			return results;
		},
		deleteStaffPersonaMappingCareSpeciality: async ({ rootGetters }, filter) => {
			const url = '/api/v3/staffpersonamappingcarespecialities';
			const results = await feathersClient.service(url).remove(null, { query: { $role: rootGetters.currentUserRole, ...filter } });
			return results;
		},
		deleteStaffPersonaMapping: async ({ rootGetters }, filter) => {
			const url = '/api/v3/staffpersonamappings';
			const results = await feathersClient.service(url).remove(null, { query: { $role: rootGetters.currentUserRole, ...filter } });
			return results;
		},
		getStaffPersonaMappingById: async ({ rootGetters }, data) => {
			const url = '/api/v3/staffpersonamappings';
			const results = await feathersClient.service(url).get(data.id, {
				query: {
					fields: ['jobTitle', 'owner', 'careSpecialities', 'staffPersonas'],
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
		getBandByNumber: async (context, filter) => {
			filter.$paginate = false;
			const url = '/api/v3/band-types';
			const results = await feathersClient.service(url).find({ query: filter });
			return results;
		},
		updateMapping: async ({ rootGetters }, data) => {
			const url = '/api/v3/staffpersonamappings';
			const results = await feathersClient.service(url).patch(data.id, data, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
	},
};
